import { PERMISSIONS } from "@/rbac/permissions.js";
import { ACCESS_LEVELS } from "@/rbac/accessLevels.js";

const VIEW_PERMISSIONS = [
  PERMISSIONS.ROLE_BMS_BROWSER,
  PERMISSIONS.ROLE_BMS_BROWSER_INSPECTION,
  PERMISSIONS.ROLE_BMS_BROWSER_INVENTORY,
  PERMISSIONS.ROLE_BMS_INSPECTOR,
  PERMISSIONS.ROLE_BMS_INSPECTOR_SUPERVISOR,
  PERMISSIONS.ROLE_BMS_POWERUSER,
  PERMISSIONS.ROLE_BMS_SUPERUSER,
  PERMISSIONS.ROLE_BMSBP_CONSULTANT_INSPECTOR_SUPERVISOR,
  PERMISSIONS.ROLE_BMSBP_CONSULTANT_OWNER_AGENT,
  PERMISSIONS.ROLE_BMSBP_GOVT_BRIDGE_OWNER,
  PERMISSIONS.ROLE_BMSBP_GOVT_BRIDGE_OWNER_AGENT,
  PERMISSIONS.ROLE_BMSBP_GOVT_BRIDGE_OWNER_INSPECTOR_SUPERVISOR,
  PERMISSIONS.ROLE_BMSBP_PRIV_BRIDGE_OWNER,
  PERMISSIONS.ROLE_BMSBP_PRIV_BRIDGE_OWNER_AGENT,
  PERMISSIONS.ROLE_BMSBP_PRIV_BRIDGE_OWNER_INSPECTOR_SUPERVISOR,
];

const EDIT_PERMISSIONS = [
  PERMISSIONS.ROLE_BMS_INSPECTOR_SUPERVISOR,
  PERMISSIONS.ROLE_BMS_POWERUSER,
  PERMISSIONS.ROLE_BMS_SUPERUSER,
  PERMISSIONS.ROLE_BMSBP_CONSULTANT_INSPECTOR_SUPERVISOR,
  PERMISSIONS.ROLE_BMSBP_CONSULTANT_OWNER_AGENT,
  PERMISSIONS.ROLE_BMSBP_GOVT_BRIDGE_OWNER,
  PERMISSIONS.ROLE_BMSBP_GOVT_BRIDGE_OWNER_AGENT,
  PERMISSIONS.ROLE_BMSBP_GOVT_BRIDGE_OWNER_INSPECTOR_SUPERVISOR,
  PERMISSIONS.ROLE_BMSBP_PRIV_BRIDGE_OWNER,
  PERMISSIONS.ROLE_BMSBP_PRIV_BRIDGE_OWNER_AGENT,
  PERMISSIONS.ROLE_BMSBP_PRIV_BRIDGE_OWNER_INSPECTOR_SUPERVISOR,
];

export const WORKFLOW_PERMISSIONS = {
  [ACCESS_LEVELS.VIEW]: VIEW_PERMISSIONS,
  [ACCESS_LEVELS.EDIT]: EDIT_PERMISSIONS,
};
